<mat-form-field class="maes">
  <mat-label>{{ to.label | translate }}</mat-label>
  <input matInput [type]="hide ? 'password' : 'text'" [formControl]="formControl">
  <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="hide">
    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
  </button>
  @if (formControl.errors) {
    <mat-error>
      <app-gwall-hint [gwall]="formControl.errors.gwall"></app-gwall-hint>
    </mat-error>
  }
</mat-form-field>